import React, { useMemo } from 'react'
import {
  ActionList,
  ActionListItemProps,
  Avatar,
  Button,
  Highlight,
  Icon,
  useSidePanel,
} from '@node-space/ui-components'
import { Application } from 'types/customers'
import { CustomerSidePanel } from '../CustomerDetails/CustomerSidePanel'
import { customerTypeLabelMap, statusLabelMap, statusVariantMap } from '../utils/utils'

export interface ApplicationItemsProps {
  applications: Application[]
}

export const ApplicationItems = ({ applications }: ApplicationItemsProps) => {
  const {
    isSidePanelOpen,
    sidePanelData: selectedApplication,
    paging,
    setIsSidePanelOpen,
    updateSidePanel,
  } = useSidePanel<Application>(applications)

  const onOpenSidePanel = (index: number) => {
    updateSidePanel(index)
    setIsSidePanelOpen(true)
  }

  const items: ActionListItemProps[] = useMemo(
    () =>
      applications?.map(({ id, externalReference, status, customerType, users }, index) => ({
        transparent: true,
        key: id,
        id,
        testId: `application-${id}`,
        Avatar: <Avatar type="entity" name={externalReference || id} />,
        title: externalReference || id,
        ...(users?.[0]?.email && { BodyPre: users[0].email }),
        HeaderHighlightLeft: (
          <Highlight iconElement={<Icon name="BuildingOffice" size="small" />} variant="emphasis">
            {customerTypeLabelMap[customerType] ?? customerType}
          </Highlight>
        ),
        ActionHighlight: (
          <Highlight {...(statusVariantMap[status] && { type: statusVariantMap[status] })}>
            {statusLabelMap[status] ?? status}
          </Highlight>
        ),
        CustomAction: (
          <Button
            variant="ghost"
            iconElement={<Icon name="DotsThreeVerticalCustom" />}
            onClick={() => onOpenSidePanel(index)}
          />
        ),
      })),
    [applications]
  )

  return (
    <>
      <ActionList id="applications-list" items={items} />
      <CustomerSidePanel
        isOpen={isSidePanelOpen}
        application={selectedApplication}
        paging={paging}
        onClose={() => setIsSidePanelOpen(false)}
      />
    </>
  )
}
